module.exports = __webpack_public_path__ + "static/media/medocs_01_thumb.d00e2d12.png";